export const VALID_CSV_COLUMNS = [
  'name',
  'phone',
  'jobTitle',
  'email',
  'accountName',
  'notes',
  'notesAgent',
  'notesSDR',
  'crmId',
] as const;

export const REQUIRED_CSV_COLUMNS = ['name', 'phone'] as const;

interface ColumnValidationResult {
  valid: boolean;
  unknownColumns: string[];
}

export function validateCsvColumns (headers: string[]): ColumnValidationResult {
  const validSet = new Set(VALID_CSV_COLUMNS.map((c) => c.toLowerCase()));
  const unknownColumns: string[] = [];

  for (const header of headers) {
    const normalized = header.trim().toLowerCase();
    if (normalized !== '' && !validSet.has(normalized)) {
      unknownColumns.push(header.trim());
    }
  }

  return {
    valid: unknownColumns.length === 0,
    unknownColumns,
  };
}
